import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import EyeIcon from '@mui/icons-material/RemoveRedEye';
import HiddenEyeIcon from '@mui/icons-material/VisibilityOff';
import WarningIcon from '@mui/icons-material/Warning';
import React, { useState } from 'react';
import UnlistDialog from './UnlistDialog';

export default function VisibilityIndicator({ blacklist, permlink }) {
  const [isUnlisted, setIsUnlisted] = useState(
    blacklist && blacklist.isUnlisted,
  );
  const [unlistOpen, setUnlistOpen] = useState(false);

  if (blacklist && blacklist.isBlacklistedFromPost)
    return (
      <Typography gutterBottom variant="h6" component="h2">
        <Tooltip
          title="Following a manual review, this post has been hidden on TravelFeed.com. This does not affect TravelFeed Hosting and Hive. You can still access the post by editing it. If you think this is a mistake, please contact us."
          placement="bottom"
        >
          <div className="pl-2 d-inline">
            <WarningIcon color="error" />
          </div>
        </Tooltip>
      </Typography>
    );

  return (
    <>
      <Tooltip title={isUnlisted ? 'Unlisted' : 'Public'}>
        <IconButton
          onClick={() => setUnlistOpen(true)}
          aria-label="Change visibility"
          size="large"
        >
          {isUnlisted ? <HiddenEyeIcon /> : <EyeIcon color="primary" />}
        </IconButton>
      </Tooltip>
      <UnlistDialog
        open={unlistOpen}
        btnText={isUnlisted ? 'Make this post visible' : 'Unlist this post'}
        dialogText={
          isUnlisted
            ? 'This post will become visible in searches, feeds and your profile page. This setting only affects TravelFeed.com, not TravelFeed Hosting or Hive.'
            : 'This post will remain accessible by direct link, but it will be hidden from searches, feeds and your profile page. This setting only affects TravelFeed.com, not TravelFeed Hosting or Hive.'
        }
        setOpen={setUnlistOpen}
        setIsUnlisted={setIsUnlisted}
        isUnlisted={isUnlisted}
        permlink={permlink}
      />
    </>
  );
}
